import * as EventBinder from './eventBinder'
import QrCodeImage from './qrCodeImage'

function DecimalDot2 (val) {
  // eslint-disable-next-line no-eval
  return eval(Math.round(val * 100) + 'e-2')
}

export default {
  EventBinder,
  QrCodeImage,
  DecimalDot2
}
